import { LogoGenerator } from '../../components/LogoGenerator';

const priorityOrder = [
    "bet365",   
    "Betway (Alaska)",
    "Pinnacle", 
    "Circa Vegas", 
    "DraftKings",
    "BookMaker",
    "Caesars", 
    "BetMGM"
  ];

  const sortSportsbooks = (sportsbooks) => {
    return sportsbooks.sort((a, b) => {
      const indexA = priorityOrder.indexOf(a);
      const indexB = priorityOrder.indexOf(b);
  
      // If not found in priority list, assign a high index to push to the end
      const safeIndexA = indexA === -1 ? Infinity : indexA;
      const safeIndexB = indexB === -1 ? Infinity : indexB;
  
      return safeIndexA - safeIndexB;
    });
  };

const SportsbookLogos = ({ sportsbooks_used_for_avg }) => {
	const sportsbooks = sortSportsbooks(sportsbooks_used_for_avg) || [];
	const firstThree = sportsbooks.slice(0, 3);
	const remaining = sportsbooks.slice(3).map((e) => {
		if (e === 'Betway (Alaska)') return 'FanDuel';
		if (e === 'bet105') return 'Pinnacle';
		return e;
	});

	return (
		<div className="flex flex-row items-center space-x-2">
			{firstThree.map((book, idx) => (
				<LogoGenerator key={idx} sportsbook={book} smallLogos />
			))}

			{remaining.length > 0 && (
				<div style={{color: "#a8abaf"}} className="relative group cursor-pointer text-sm text-gray-600">
					+{remaining.length}
					<div className="absolute left-1/2 transform -translate-x-1/2 mt-2 w-max max-w-xs bg-black text-white text-xs rounded-md px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
						{remaining.join(', ')}
					</div>
				</div>
			)}
		</div>
	);
};

export default SportsbookLogos;
